import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { eur, dateIt } from "@/lib/format";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import ClientEnrollmentStatus from "@/components/app/ClientEnrollmentStatus";
import { RotateCcw } from "lucide-react";

const emptyF = { course_id: "all", status: "all", date_from: "", date_to: "" };

export default function ClienteEnrollments() {
  const [rows, setRows] = useState([]);
  const [courses, setCourses] = useState([]);
  const [f, setF] = useState(emptyF);

  const load = useCallback(() => {
    const params = Object.fromEntries(Object.entries(f).filter(([, v]) => v && v !== "all"));
    api.get("/cliente/enrollments", { params }).then((r) => setRows(r.data));
  }, [f]);
  useEffect(() => { load(); }, [load]);
  const [showPrices, setShowPrices] = useState(false);
  useEffect(() => {
    api.get("/cliente/catalog").then((r) => setCourses(r.data));
    api.get("/cliente/me").then((r) => setShowPrices(r.data.billing_mode !== "slot"));
  }, []);

  return (
    <div className="space-y-6" data-testid="cliente-enrollments">
      <div>
        <h1 className="font-display text-3xl font-extrabold text-slate-900">Storico iscrizioni</h1>
        <p className="text-slate-500 mt-1">Tutte le iscrizioni effettuate dalla tua azienda.</p>
      </div>
      <Card className="border-slate-200"><CardContent className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 items-end">
        <div><Label className="text-xs">Corso</Label>
          <Select value={f.course_id} onValueChange={(v) => setF({ ...f, course_id: v })}>
            <SelectTrigger data-testid="filter-course"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="all">Tutti i corsi</SelectItem>{courses.map((c) => <SelectItem key={c.course_id} value={c.course_id}>{c.title}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        <div><Label className="text-xs">Stato</Label>
          <Select value={f.status} onValueChange={(v) => setF({ ...f, status: v })}>
            <SelectTrigger data-testid="filter-status"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="all">Tutti</SelectItem><SelectItem value="confermata">Confermata</SelectItem><SelectItem value="annullata">Annullata</SelectItem></SelectContent>
          </Select>
        </div>
        <div><Label className="text-xs">Data da</Label><Input type="date" value={f.date_from} onChange={(e) => setF({ ...f, date_from: e.target.value })} data-testid="filter-date-from" /></div>
        <div><Label className="text-xs">Data a</Label><Input type="date" value={f.date_to} onChange={(e) => setF({ ...f, date_to: e.target.value })} data-testid="filter-date-to" /></div>
        <Button variant="outline" onClick={() => setF(emptyF)} data-testid="filter-reset"><RotateCcw className="w-4 h-4 mr-1" /> Azzera filtri</Button>
      </CardContent></Card>
      <Card className="border-slate-200"><CardContent className="p-0 overflow-x-auto">
        <Table>
          <TableHeader><TableRow>
            <TableHead>Data iscrizione</TableHead><TableHead>Numero</TableHead><TableHead>Corsista</TableHead>
            <TableHead>Corso</TableHead><TableHead>Edizione</TableHead>{showPrices && <TableHead>Prezzo</TableHead>}<TableHead>Stato</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {rows.map((e) => (
              <TableRow key={e.id} data-testid={`cliente-enrollment-row-${e.enrollment_number}`}>
                <TableCell>{dateIt(e.created_at)}</TableCell>
                <TableCell className="font-semibold">{e.enrollment_number}</TableCell>
                <TableCell>{e.first_name} {e.last_name}<div className="text-xs text-slate-500">{e.email}</div></TableCell>
                <TableCell>{e.course_title}</TableCell>
                <TableCell className="text-xs">{e.edition_label || "—"}</TableCell>
                {showPrices && <TableCell data-testid={`cliente-enrollment-price-${e.enrollment_number}`}>{eur(e.unit_price)} {Number(e.vat_rate) === 0
                  ? <span className="ml-1 inline-flex px-2 py-0.5 rounded-full text-[10px] font-bold uppercase bg-sky-100 text-sky-800">Esente IVA</span>
                  : <span className="text-xs text-slate-500">+ IVA {e.vat_rate}%</span>}</TableCell>}
                <TableCell><ClientEnrollmentStatus status={e.status} /></TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && <TableRow><TableCell colSpan={7} className="text-center text-slate-500 py-10">Nessuna iscrizione trovata.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </CardContent></Card>
    </div>
  );
}
